<template>
    <b-nav vertical class="main-sidebar" :style="{'padding-left': indent * 10 + 'px'}">
        <b-nav-item v-for="(link, i) in links">
            <sidebar-link :link="link" :indent="indent">
                <template #default>
                    {{ link.title }}
                </template>
            </sidebar-link>
        </b-nav-item>
    </b-nav>
</template>

<script>
    export default {
        name: "Sidebar",
        components: {
            SidebarLink: () => import('./SidebarLink.vue')
        },
        props: {
            links: { type: Array },
            indent: {type: Number, default: 0}
        }
    }
</script>

<style lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    $hover-color: lighten($dark, 8%);
    $active-color: darken($info, 15%);
    $sidebar-text-link-color: $gray-300;

    .main-sidebar a, .main-sidebar .btn.btn-link {
        color: $sidebar-text-link-color !important;
        &:hover { color: $sidebar-text-link-color !important; text-decoration: none; }
        &:focus { box-shadow: none !important }
    }

    .main-sidebar li a.active {
        background-color: $active-color;
        &:hover {
            background-color: lighten($active-color, 8%)
        }
    }

    .main-sidebar .collapse .nav-link {
         border-left: 3px solid $info;
     }


    .main-sidebar .nav-link {
        padding: 0 !important;

        & div > a > div {
            padding: 0.5rem 1rem;

            &:hover {
                background-color: $hover-color;
            }
        }

        & div > a.active > div {
            background-color: $active-color;
            &:hover {
                background-color: lighten($active-color, 8%)
            }
        }
    }
</style>